import { useEffect, useState } from "react";

export const useAppColors = (): string[] => {
    const [colors, setColors] = useState<string[]>([]);

    useEffect(() => {
        const get = (name: string) =>
            getComputedStyle(document.documentElement).getPropertyValue(name).trim();

        setColors([
            get("--primary-500"),
            get("--secondary-500"),
            get("--success-500"),
            get("--danger-500"),
            get("--warning-500"),
            get("--info-500"),
            get("--primary-300"),
            get("--secondary-400"),
            get("--success-400"),
            get("--danger-400"),
            get("--warning-400"),
            get("--info-400"),
        ].filter(Boolean));
    }, []);

    return colors;
};
